import { Card } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { setHeader, setRoutes } from 'src/core/ui/shell';

const EulaPage: FC<{}> = () => {
  const { t } = useTranslation();

  setHeader(t('EULATitle'));
  setRoutes([
    { path: '', breadcrumbName: t('Home') },
    { path: 'eula', breadcrumbName: t('EULATitle') },
  ]);

  return (
    <Card className="eula-card">
      <div className="eula-body">
        {t('EULABody')
          .split('\n')
          .map((v) => {
            return <p>{v}</p>;
          })}
      </div>
    </Card>
  );
};

export default EulaPage;
